<div class="main-tab">
  <app-section-header [title]="'Main'" />
  <contact-information [formFields]="contactInfo" [formData]="contactFormData"
    (modelDataChange)="onContactInfoChange($event)"></contact-information>
  <div class="customer-information">
    <div class="title">Mailing Address</div>
    <address *ngIf="true" [(modelData)]="servicerService.mailingAddressFinal" [enableModelData]="true"></address>
  </div>
  <div class="customer-information">
    <div class="title">Billing Address</div>
    <address *ngIf="true" [(modelData)]="servicerService.billingAddressFinal" [enableModelData]="true"></address>
  </div>
</div>